/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "I",
    title: "Thuế TNDN đối với dầu khí xuất bán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    unit: "USD",
    spendId: "26",
    title: "Tổng doanh thu chịu thuế TNDN trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    unit: "USD",
    index: "2",
    spendId: "27",
    title: "Tổng chi phí được trừ khi xác định thu nhập chịu thuế trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    unit: "USD",
    spendId: "28",
    title: "Tổng thu nhập chịu thuế trong kỳ tính thuế [28]=[26]-[27]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    spendId: "29",
    unit: "%",
    title: "Thuế suất thuế TNDN (50%)",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    spendId: "30",
    unit: "USD",
    title: "Số tiền thuế thu nhập doanh nghiệp từ hoạt động dầu khí [30]=[28]x[29]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "II",
    title: "Thuế TNDN đối với thu nhập từ tiền kết dư của phần dầu để lại",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    spendId: "31",
    unit: "USD",
    title: "Thu nhập chịu thuế trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "2",
    spendId: "32",
    unit: "%",
    title: "Thuế suất thuế TNDN (50%)",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    spendId: "33",
    unit: "%",
    title:
      "Số tiền thuế thu nhập doanh nghiệp đối với thu nhập từ tiền kết dư của phần dầu để lại [33]=[31]x[32]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "III",
    unit: "USD",
    spendId: "34",
    title: "Số tiền thuế TNDN phải nộp trong kỳ tính thuế [34]=[30]+[33]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "IV",
    unit: "USD",
    spendId: "35",
    title: "Số tiền thuế TNDN tạm tính đã kê khai trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "V",
    unit: "USD",
    spendId: "36",
    title:
      "Chênh lệch giữa số tiền phải nộp theo quyết toán với số đã kê khai trong kỳ tính thuế [36]=[34]-[35]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    unit: "VND/USD",
    spendId: "37",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) => ["28", "30", "33", "34", "36"].includes(spendId) || !spendId;
  const isBold = (index) => ["I", "II", "III", "IV", "V"].includes(index);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.index) ? 900 : 400,
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.index) ? 900 : 400,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.index) ? 900 : 400,
                  }}
                >
                  {item.spendId ? `[${item.spendId}]` : ""}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.index) ? 900 : 400,
                  }}
                >
                  {item.unit}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.index) ? 900 : 400,
                  }}
                >
                  {isDisabled(item.spendId) ? (
                    ""
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
